module.exports = "/images/125e6ba6a62e34195a31250271a386e2.svg";